import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Link,
  IconButton,
  Divider,
  styled
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import Logo from '../Header/Logo';

const FooterLink = styled(Link)(({ theme }) => ({
  color: theme.palette.grey[300],
  textDecoration: 'none',
  transition: 'color 0.3s ease',
  display: 'block',
  marginBottom: theme.spacing(1),
  '&:hover': {
    color: theme.palette.primary.light,
  }
}));

const SocialIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: 'rgba(94, 53, 177, 0.1)',
  marginRight: theme.spacing(1),
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    transform: 'translateY(-3px)',
  }
}));

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box 
      sx={{ 
        bgcolor: 'grey.900',
        color: 'grey.100',
        py: 6,
        borderTop: '1px solid rgba(0, 0, 0, 0.06)'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 3 }}>
              <Logo />
            </Box>
            <Typography variant="body2" color="grey.400" sx={{ mb: 3 }}>
              Аналитическая платформа для отслеживания продаж NFT-коллекций. Получайте актуальную информацию о статистике продаж с OpenSea.
            </Typography>
            <Box sx={{ display: 'flex', mb: 3 }}>
              <SocialIconButton aria-label="Facebook">
                <FacebookIcon />
              </SocialIconButton>
              <SocialIconButton aria-label="Twitter">
                <TwitterIcon />
              </SocialIconButton>
              <SocialIconButton aria-label="Instagram">
                <InstagramIcon />
              </SocialIconButton>
              <SocialIconButton aria-label="Telegram">
                <TelegramIcon />
              </SocialIconButton>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={4} md={2}>
            <Typography variant="h6" fontWeight="600" gutterBottom>
              Компания
            </Typography>
            <FooterLink href="#">О нас</FooterLink>
            <FooterLink href="#">Блог</FooterLink>
            <FooterLink href="#">Карьера</FooterLink>
            <FooterLink href="#">Контакты</FooterLink>
          </Grid>
          
          <Grid item xs={12} sm={4} md={3}>
            <Typography variant="h6" fontWeight="600" gutterBottom>
              Возможности
            </Typography>
            <FooterLink href="#">NFT Аналитика</FooterLink>
            <FooterLink href="#">Дашборд</FooterLink>
            <FooterLink href="#">Отчеты</FooterLink>
            <FooterLink href="#">Интеграции</FooterLink>
          </Grid>
          
          <Grid item xs={12} sm={4} md={3}>
            <Typography variant="h6" fontWeight="600" gutterBottom>
              Поддержка
            </Typography>
            <FooterLink href="#">Документация</FooterLink>
            <FooterLink href="#">Помощь</FooterLink>
            <FooterLink href="#">FAQ</FooterLink>
            <FooterLink href="#">Сообщество</FooterLink>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.12)' }} />
        
        {/* Acknowledgement with logo on the left */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 3,
          flexWrap: 'wrap'
        }}>
          <Box component="img"
            src="/logo_w.svg"
            alt="Логотип"
            sx={{ height: 48, width: 'auto' }}
          />
          <Typography variant="body2" color="grey.400" sx={{ maxWidth: 900 }}>
            Проект создан при поддержке Федерального государственного бюджетного учреждения
            "Фонд содействия развитию малых форм предприятий в научно-технической сфере" в
            рамках программы "Студенческий стартап" федерального проекта "Платформа
            университетского технологического предпринимательства".
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <Typography variant="body2" color="grey.400">
            © {currentYear} ArtNFT. Все права защищены.
          </Typography>
          <Box>
            <FooterLink href="#" sx={{ display: 'inline', mr: 3 }}>
              Политика конфиденциальности
            </FooterLink>
            <FooterLink href="#" sx={{ display: 'inline' }}>
              Условия использования
            </FooterLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 